import React from 'react';
export function CertifiedWiresSection() {
  return <div className="bg-white p-8 rounded-xl shadow-sm border border-gray-200 text-center space-y-6" data-id="element-4423">
      <h3 className="text-2xl font-bold text-[#026ab7] max-w-3xl mx-auto" data-id="element-4424">
        GF Machining Solutions offers you a wide range of certified EDM wires
        perfectly adapted to your machining requirements.
      </h3>
      <p className="text-gray-700 leading-relaxed max-w-4xl mx-auto" data-id="element-4425">
        A wire EDM machine has a very wide range of applications and the choice
        of wire is crucial in order to obtain the best productivity and optimum
        results in terms of speed, precision and surface finish. Processes for
        technological development, product accreditation and production control
        in cooperation with strategic partners ensure that with GF Machining
        Solutions certified wire your equipment is operating at peak precision
        and performance. Even if you do not have any GF Machining Solutions
        machines, you can benefit from Operations Support.
      </p>
      <div className="pt-4 space-y-4" data-id="element-4426">
        <img src="https://drwzpk38qkpfb.cloudfront.net/www.peakedm.com/uploaded/images/2022%20Machine%20Photos/Cerified%20Wires.png800x800.png" alt="Certified Wires" className="block mx-auto max-w-full h-auto" data-id="element-4427" />
        <a href="https://www.peakedm.com/uploaded/files/2022%20GFMS%20Brochures/Wire%20EDM/Certified%20Wire%20for%20EDM.pdf?direct=1" target="_blank" rel="noopener noreferrer" className="inline-block text-navy font-bold text-lg underline hover:text-orange transition-colors" data-id="element-4428">
          Certified Wire Brochure
        </a>
      </div>
    </div>;
}